import OwnMarginOrLTV from "./OwnMarginOrLTV";

export default OwnMarginOrLTV;
